import "./App.scss";
import Home from "./pages/Home";
import Header from "./components/Header";

function App() {
  return (
    <>
      <Header />
      <Home />
    </>
  );
}

export default App;
